<template>
    <ModalTheme :overlay="false" @close="cancel" :loading="loading || parentLoading">
        <template slot="main">
            <div v-if="profile">
                <h1 class="txtCenter" style="font-size: xx-large;">{{ "Edit Profile" }}</h1>
                <div class="form-group row">
                    <TextInputBloc :label="'name'" :required="true" v-model="profile.name" :max-length="99"></TextInputBloc>
                </div>
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />

                <div>
                    <div style="text-align: center">
                        <p>Do you want to Edit the rights</p>
                        <span class="roundedIcon2 pointer" @click="$emit('editRight', this.profileId);"> {{ "Edit Rights" }} </span>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="false" slot="overlay"> </template>
        <template slot="footer">
            <client-color-button @click="save"> {{ "Save Profile" }} </client-color-button>
        </template>
    </ModalTheme>
</template>

<script>
import cacheService from "@/services/cache";
import Multiselect from "vue-multiselect";
import TryLoad from "@/mixins/TryLoadMixin";
import ModalTheme from "@/components/ui/ModalTheme";
import TextInputBloc from "@/components/ui/Form/TextInputBloc";
import userService from "@/services/user";

export default {
    data: () => ({
        loading: false,
        profile: {
            name: null
        }
    }),
    watch: {},
    props: {
        parentLoading: {
            type: Boolean,
            required: false,
            default: false
        },
        profileId: {
            type: Number,
            required: true
        }
    },
    components: {
        TextInputBloc,
        Multiselect,
        ModalTheme
    },
    mixins: [TryLoad],
    methods: {
        cancel() {
            this.$emit("cancel");
        },
        async save() {
            await this.tryLoad(() => userService.updateProfile(this.profile));
            location.reload();
        }
    },
    async created() {
        this.profile = await this.tryLoad(() => userService.getProfile(this.profileId));
    }
};
</script>

<style scoped lang="scss">
@import "../../../assets/css/themes";
</style>



// WEBPACK FOOTER //
// EditProfile.vue?8f809eba